import { useState, KeyboardEvent } from "react";
import { Goban } from "./Goban";

import {
  DbKey,
  Game,
  FrontendToBackend,
  BackendToFrontend,
  FrontendGames,
  GameEvent,
  FrontendGameMap,
  Player,
} from "./backend-types";
import useWebSocket from "react-use-websocket";

// GameList

type GameListProps = {
  games: FrontendGames | null;
  sendF2b: (f2b: FrontendToBackend) => void;
};

function GameList({ games, sendF2b }: GameListProps) {
  async function gameClick(game: DbKey<Game>) {
    let f2b: FrontendToBackend = {
      enum_tag: "GameClick",
      content: {
        game: game,
      },
    };
    sendF2b(f2b);
  }

  return (
    <div className="GameList">
      {games?.games.map((game) => (
        <div
          className="Game"
          key={game.key.idx}
          onClick={() => gameClick(game.key)}
        >
          {game.val.name}
        </div>
      ))}
    </div>
  );
}

// EventList

type EventListProps = {
  gameMap: FrontendGameMap | null;
  sendF2b: (f2b: FrontendToBackend) => void;
};

function EventList({ gameMap, sendF2b }: EventListProps) {
  async function onClick(event: GameEvent) {
    let f2b: FrontendToBackend = {
      enum_tag: "EventClick",
      content: {
        pos: event.pos,
      },
    };
    sendF2b(f2b);
  }

  return (
    <div className="EventList">
      {gameMap?.events?.map((eventRow) => {
        return (
          <div className="EventRow">
            {eventRow.map((event) => {
              const className =
                event.stone.player === Player.Black ? "BlackMove" : "WhiteMove";
              const currentStyle = {
                borderStyle: "solid",
                borderColor: "red",
                borderWidth: "5px",
              };
              return (
                <div
                  className={className}
                  onClick={() => onClick(event)}
                  style={event.is_current ? currentStyle : {}}
                >
                  {event.text}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

// App

function App() {
  const [b2f, setB2f] = useState<BackendToFrontend | null>(null);

  const onMessage = function (event: WebSocketEventMap["message"]) {
    const rb2f = JSON.parse(event.data);
    console.log("Message from server ", rb2f);

    if (rb2f.hasOwnProperty("Ok")) {
      const b2f: BackendToFrontend = rb2f.Ok;
      setB2f(b2f);
    } else if (rb2f.hasOwnProperty("Err")) {
      alert("Server sent error: " + rb2f.Err);
    } else {
      alert("Should not happen");
    }
  };

  const { REACT_APP_BACKEND_ADDRESS } = process.env;
  const backendAddress = process.env.REACT_APP_BACKEND_ADDRESS;
  console.log('Backend Address:', backendAddress);

  const { sendMessage } = useWebSocket(
    "ws://" + REACT_APP_BACKEND_ADDRESS + "/ws",
    {
      onMessage,
      // onOpen: () => sendMessage(JSON.stringify({ enum_tag: "NewClient" })),
    }
  );

  function sendF2b(f2b: FrontendToBackend) {
    sendMessage(JSON.stringify(f2b));
  }

  function onKeyPress(event: KeyboardEvent<HTMLImageElement>) {
    sendF2b({ enum_tag: "KeyboardPress", content: { key: event.key } });
    console.log(event.key);
  }

  return (
    <div className="App" onKeyDown={onKeyPress} tabIndex={0}>
      <Goban pos={b2f?.goban ?? null} sendF2b={sendF2b} />
      <EventList gameMap={b2f?.game_map ?? null} sendF2b={sendF2b} />
      <GameList games={b2f?.games ?? null} sendF2b={sendF2b} />
    </div>
  );
}

export default App;
